import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, useForm } from "@jti/ui";
export const ConsumablesForm = ({ isSubscriptionsEnabled, isOutOfStockProductSelected, isCartLoaded,
// setIsSubscriptionSelected, // TODO: Uncomment when matrix is ready
 }) => {
    const form = useForm({
        defaultValues: {},
    });
    const handleSubmit = (data /* TODO: Fix after matrix with actual data is ready */) => {
        console.log("Form submitted with data:", data);
    };
    return (_jsxs(Form, { form: form, onSubmit: handleSubmit, children: [_jsx("h1", { children: "Consumables Form" }), isSubscriptionsEnabled && _jsx("p", { children: "Subscription is enbaled" }), isOutOfStockProductSelected && _jsx("p", { children: "Product is out of stock" }), isCartLoaded && _jsx("p", { children: "Cart is loaded" })] }));
};
//# sourceMappingURL=ConsumablesForm.js.map